import { useEffect } from "react";

export const usePageMeta = (title, description) => {
    useEffect(() => {
        document.title = title;
        const tag = document.querySelector('meta[name="description"]');
        if (tag) tag.setAttribute("content", description);
    }, [title, description]);
};
